import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const { 
  pmsBegin, 
  pmsSuccess,
  pmsErr,

  createPmsBegin,
  createPmsSuccess,
  createPmsErr,
 } = actions;

//  manageHost actionCreator.js api added here for temperory use
const pmsDataAPI = '/admin/get-pms-list';
const createPmsAuthAPI = '/admin/create-pms-auth';
const getConnectedPmsAPI = '/admin/get-connected-pms'
const postPartnerAPI = '/admin/post-partner-detail';
const getPartnerDetailAPI = '/admin/get-partner-detail';

const getPmsData = (value = "") => {
  return async (dispatch) => {
    dispatch(pmsBegin());
    try {
      const response = await DataService.get(pmsDataAPI + value);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(pmsErr(response?.data?.message));
      } else {
        dispatch(pmsSuccess(response?.data));
      }
      return response?.data?.result;
    } catch (err) {
      dispatch(pmsErr(err));
    }
  };
};

const getPmsAuth = (values) => {
  return async (dispatch) => {
    dispatch(createPmsBegin());
    try {
      const response = await DataService.post(createPmsAuthAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(createPmsErr(response?.data?.message));
      } else {
        dispatch(createPmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(createPmsErr(err));
    }
  };
};

const getConnectedPms = (values) => {
  return async (dispatch) => {
    dispatch(pmsBegin());
    try {
      const response = await DataService.post(getConnectedPmsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(pmsErr(response?.data?.message));
      } else {
        dispatch(pmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(pmsErr(err));
    }
  };
};

const postPartnerDetails = (values) => {
  return async (dispatch) => {
    dispatch(pmsBegin());
    try {
      const response = await DataService.post(postPartnerAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(pmsErr(response?.data?.message));
      } else {
        dispatch(pmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(pmsErr(err));
    }
  };
};

const getPartnerDetails = (values) => {
  return async (dispatch) => {
    dispatch(pmsBegin());
    try {
      const response = await DataService.post(getPartnerDetailAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(pmsErr(response?.data?.message));
      } else {
        dispatch(pmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(pmsErr(err));
    }
  };
};

export { getPmsData, getPmsAuth, getConnectedPms, postPartnerDetails, getPartnerDetails};
